<template>
  <div>
    <div class="h5 font-weight-bold mb-4">Select category for this Micro-Credentials</div>
    <b-dropdown
      ref="dropdown"
      v-model="selectedCategory"
      class="base__select-mc-category"
      variant="outline-primary"
      :text="title"
      :disabled="disabled"
      @hide="onSearchReset"
    >
      <b-dropdown-form>
        <SearchBar
          ref="search-category-input"
          v-model="searchKeyWords"
          class="input__search-category"
          placeholder="Search here..."
          hide-icon-search
          on-change-mode
          @reset="onSearchReset"
        />
      </b-dropdown-form>

      <div v-if="isLoading" key="loading" class="d-flex justify-content-center p-4 m-3">
        <b-spinner label="Loading..." variant="dark" />
      </div>

      <div v-else>
        <b-dropdown-item
          v-for="category in categories"
          :id="`category-${category.id}`"
          ref="categories-dropdown-item"
          :key="category.id"
          :active="category.id == selectedCategory"
          :value="category.name"
          @click.prevent.stop="onSelected(category)"
          >{{ category.name }}</b-dropdown-item
        >
        <b-dropdown-item v-if="!categories.length" disabled>No results found</b-dropdown-item>
      </div>
    </b-dropdown>
  </div>
</template>
<script>
import { debounce } from 'lodash';
import Category from '@/models/Category';
import SearchBar from './SearchBar';

export default {
  components: {
    SearchBar
  },

  model: {
    prop: 'modelValue',
    event: 'change'
  },

  props: {
    modelValue: {
      type: Number,
      default: () => null
    },

    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      searchKeyWords: [],
      categories: [],
      selectedCategory: '',
      isLoading: false
    };
  },
  computed: {
    title: {
      get() {
        return this.selectedCategory
          ? Category.find(this.selectedCategory).name
          : 'Please select...';
      },

      set(value) {
        this.selectedCategory = value;
      }
    }
  },
  watch: {
    modelValue: {
      immediate: true,
      handler(modelValue) {
        this.selectedCategory = modelValue;
      }
    },

    searchKeyWords: {
      async handler() {
        await this.fetchCategories();
      },
      deep: true
    }
  },
  mounted() {
    this.fetchCategories();
    this.fetchCategories = debounce(this.fetchCategories, 500);
  },

  methods: {
    async onSearchReset() {
      this.searchKeyWords = [];
      await this.fetchCategories();
    },

    async fetchCategories() {
      this.isLoading = true;
      const filter = {};

      if (this.searchKeyWords.length) this.$set(filter, 'name', this.searchKeyWords);

      try {
        this.categories = await Category.api().categories(filter);
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },

    onSelected(value) {
      this.selectedCategory = value.id;
      this.title = value.name;
      this.$emit('change', value.id);
    }
  }
};
</script>

<style lang="scss" scoped></style>
